import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import ScrollReveal from '@/components/base/ScrollReveal';

export default function FAQ() {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    { q: t('phoenix.faq1Q'), a: t('phoenix.faq1A') },
    { q: t('phoenix.faq2Q'), a: t('phoenix.faq2A') },
    { q: t('phoenix.faq3Q'), a: t('phoenix.faq3A') },
    { q: t('phoenix.faq4Q'), a: t('phoenix.faq4A') },
    { q: t('phoenix.faq5Q'), a: t('phoenix.faq5A') },
    { q: t('phoenix.faq6Q'), a: t('phoenix.faq6A') },
    { q: t('phoenix.faq8Q'), a: t('phoenix.faq8A') },
  ];

  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="relative py-20 md:py-28 bg-white">
      <div className="mx-auto max-w-[800px] px-6 md:px-10">
        <ScrollReveal direction="up">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 border border-primary-200/50 text-primary-700 text-xs font-semibold tracking-wide uppercase mb-4">
            {t('phoenix.faqTag')}
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-16 text-center">
            Resolvemos tus <span className="text-primary-500">dudas.</span>
          </h2>
        </ScrollReveal>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <ScrollReveal key={i} direction="up" delay={i * 0.04}>
              <div className="rounded-2xl bg-white border border-background-200/70 shadow-[0_2px_8px_rgba(0,0,0,0.02)] overflow-hidden">
                <button
                  onClick={() => toggleFaq(i)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer group"
                >
                  <span className="text-foreground-800 font-medium text-sm md:text-base pr-4 group-hover:text-primary-600 transition-colors duration-200">
                    {faq.q}
                  </span>
                  <div className={`w-7 h-7 rounded-full border flex items-center justify-center shrink-0 transition-all duration-300 ${openIndex === i ? 'border-primary-500 bg-primary-50 rotate-180' : 'border-background-300 bg-white'}`}>
                    <i className={`ri-arrow-down-s-line text-sm ${openIndex === i ? 'text-primary-600' : 'text-foreground-500'}`}></i>
                  </div>
                </button>
                <AnimatePresence initial={false}>
                  {openIndex === i && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: 'auto', opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
                      className="overflow-hidden"
                    >
                      <p className="px-6 pb-6 text-foreground-600 text-sm leading-relaxed">
                        {faq.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}